import React from 'react';
import PropTypes from 'prop-types';
import { useIntl, FormattedMessage } from 'react-intl';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import s from './Reviews.css';

// Components
import Avatar from '../Avatar';
import StarRating from '../StarRating/StarRating';

// Locale
import messages from '../../locale/messages';

const ResponseItem = ({ data, otherUserResponse = false, date, showReviewName }) => {
	const intl = useIntl();
	const formatMessage = intl.formatMessage;

	const {
		authorData: { firstName, lastName, profileId, picture },
		reviewContent,
		rating
	} = data;

	return (
		<div className={s.responseFlex}>
			<div className={cx(s.reviewBody, s.pullLeft, 'floatRight')}>
				<Avatar
					source={picture}
					height={48}
					width={48}
					title={firstName}
					className={s.profileAvatar}
					withLink
					linkClassName={cx(s.avatarDisplay, s.profileAvatarLink)}
					profileId={profileId}
				/>
			</div>
			<div className={s.reviewBody}>
				<span className={cx(s.textBold, s.nameBold)}>
					{otherUserResponse
						? firstName
						: showReviewName
							? firstName
							: formatMessage(messages.your)}{' '}
					<FormattedMessage {...messages.response} />:
				</span>

				{reviewContent && (
					<div className={s.reviewFlex}>
						<StarRating className='smallStarRatingAdjust' />
						<div>{rating}</div>
						<div className={cx(s.dateReviewCss, 'dateReviewCssRTL')}>
							{date}
						</div>
					</div>
				)}

				<p className={cx(s.wordbreak, s.spaceTop1)}>
					{reviewContent}
				</p>
			</div>
		</div>
	);
};

ResponseItem.propTypes = {
	data: PropTypes.shape({
		authorData: PropTypes.shape({
			picture: PropTypes.string,
			firstName: PropTypes.string,
			lastName: PropTypes.string,
			profileId: PropTypes.number,
		}),
		reviewContent: PropTypes.string,
		rating: PropTypes.number,
	}),
	otherUserResponse: PropTypes.bool,
	date: PropTypes.string,
	showReviewName: PropTypes.bool
};

export default withStyles(s)(ResponseItem);